import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { RestaurantWithEventSpaces } from "@/types/restaurant";

/**
 * Custom hook to fetch featured restaurants that are:
 * - Approved by admin
 * - Currently featured (featured_until > current date)
 * - Ordered by most recently updated
 */
export const useFeaturedRestaurants = () => {
  return useQuery({
    queryKey: ['featuredRestaurants'],
    queryFn: async () => {
      console.log('Fetching featured restaurants...');
      const { data, error } = await supabase
        .from('restaurants')
        .select(`
          *,
          neighborhood:neighborhoods(
            id,
            name,
            city:cities(
              name,
              state
            )
          ),
          eventspaces (
            id,
            restaurant_id,
            space_name,
            capacity,
            event_types,
            description,
            photos,
            amenities:eventspace_amenities(
              amenity:amenities(*)
            ),
            pricing_tiers(*)
          )
        `)
        .eq('is_featured', true)
        .eq('approval_status', 'approved')
        .gt('featured_until', new Date().toISOString())
        .order('updated_at', { ascending: false });
      
      if (error) {
        console.error('Error fetching featured restaurants:', error);
        throw error;
      }
      
      console.log('Featured restaurants:', data);
      return data as RestaurantWithEventSpaces[];
    },
  });
};